import axios, { type AxiosRequestConfig } from 'axios'
import { attachDeviceIdHeader } from './deviceId'
import { APP_VERSION_HEADER, recordServedAppVersion } from '@/composables/useAppVersion'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true

const token: string | null = window.PnBaseData.security.csrfToken ?? null

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token
}

// Attach the device fingerprint to every request so the backend session-risk
// scorer can detect a session used from a different device. The interceptor
// awaits the (memoised) fingerprint, so the first request resolves it and every
// later request reuses the cached value.
axios.interceptors.request.use(attachDeviceIdHeader)

// Every authenticated response carries the deploy that served it, so any request the app
// already makes tells us when this tab's bundle has fallen behind a deploy.
axios.interceptors.response.use(
    (response) => {
        recordServedAppVersion(response.headers?.[APP_VERSION_HEADER])

        return response
    },
    (error) => {
        recordServedAppVersion(error?.response?.headers?.[APP_VERSION_HEADER])

        return Promise.reject(error)
    },
)

export type EndpointType = {
    method: string
    url: string
}

export function addPrecognitionHeaders(headers: AxiosRequestConfig['headers'], fields?: string[]) {
    if (fields) {
        headers = {
            ...headers,
            Precognition: 'true',
        }

        if (fields.length) {
            headers = {
                ...headers,
                'Precognition-Validate-Only': fields,
            }
        }
    }

    return headers
}

export default axios
